import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { useSalesContext } from "../../SalesContext";

interface DataItem {
  managerId: number;
  managerName: string;
  totalCount: number;
  inGreen: number;
  inGreenPercent: string;
  inYellow: number;
  inYellowPercent: string;
  inRed: string;
  inRedPercent: string;
}

interface KpiTableProps {
  tableData: {
    tabTitle: string;
    data: DataItem[];
  };
}

const KpiTable: React.FC<KpiTableProps> = ({ tableData }) => {
  console.log(tableData);
  const { userID } = useSalesContext();
  const [showAllRows, setShowAllRows] = useState(false);

  const normalizedUserID =
    typeof userID === "string" ? parseInt(userID, 10) : userID;

  const userRow = tableData.data.find(
    (row) => row.managerId === normalizedUserID
  );

  const isRestrictedTitle = ["MR", "SLM", "FLM"].includes(tableData.tabTitle);
  let displayData: DataItem[] = [];

  if (isRestrictedTitle) {
    if (userRow) {
      displayData = showAllRows
        ? [
            userRow,
            ...tableData.data.filter(
              (row) => row.managerId !== normalizedUserID
            ),
          ]
        : [userRow];
    } else {
      displayData = showAllRows ? tableData.data : [];
    }
  } else {
    displayData = tableData.data;
  }

  const handleRowClick = () => {
    setShowAllRows((prev) => !prev);
  };

  return (
    <div>
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          textTransform: "capitalize",
          fontSize: "18px",
          fontWeight: "bold",
          border: "1px solid #75A1C6",
          margin: "0",
          padding: "12px",
        }}
      >
        {tableData.tabTitle} KPI SUMMARY
      </Typography>
      <TableContainer
        component={Paper}
        sx={{ maxHeight: "200px", overflow: "auto" }}
      >
        <Table stickyHeader>
          <TableHead sx={{ backgroundColor: "#E9F4FA" }}>
            <TableRow>
              <TableCell
                sx={{ color: "#3B459E", fontSize: "12px", fontWeight: "bold" }}
              >
                Manager Name
              </TableCell>
              <TableCell
                sx={{ color: "#3B459E", fontSize: "12px", fontWeight: "bold" }}
                align="center"
              >
                Total {tableData.tabTitle} Count
              </TableCell>
              <TableCell
                sx={{ color: "#3B459E", fontSize: "12px", fontWeight: "bold" }}
                align="center"
              >
                {tableData.tabTitle} in Green Zone
              </TableCell>
              <TableCell
                sx={{ color: "#3B459E", fontSize: "12px", fontWeight: "bold" }}
                align="center"
              >
                {tableData.tabTitle} in Yellow Zone
              </TableCell>
              <TableCell
                sx={{ color: "#3B459E", fontSize: "12px", fontWeight: "bold" }}
                align="center"
              >
                {tableData.tabTitle} in Red Zone
              </TableCell>
              <TableCell
                sx={{ color: "#3B459E", fontSize: "12px", fontWeight: "bold" }}
                align="center"
              >
                {tableData.tabTitle} % in Green Zone
              </TableCell>

              <TableCell
                sx={{ color: "#3B459E", fontSize: "12px", fontWeight: "bold" }}
                align="center"
              >
                {tableData.tabTitle} % in Yellow Zone
              </TableCell>
              <TableCell
                sx={{ color: "#3B459E", fontSize: "12px", fontWeight: "bold" }}
                align="center"
              >
                {tableData.tabTitle} % in Red Zone
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayData.length > 0 ? (
              displayData.map((row, index) => (
                <TableRow
                  key={index}
                  onClick={
                    isRestrictedTitle && row.managerId === normalizedUserID
                      ? handleRowClick
                      : undefined
                  }
                  sx={{
                    cursor:
                      isRestrictedTitle && row.managerId === normalizedUserID
                        ? "pointer"
                        : "default",
                    backgroundColor: "inherit",
                    "&:hover": {
                      backgroundColor:
                        row.managerId === normalizedUserID
                          ? "#0044CC"
                          : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      backgroundColor:
                        row.managerId === normalizedUserID
                          ? "#FFFFFF"
                          : "inherit",
                      color:
                        row.managerId === normalizedUserID
                          ? "#000000"
                          : "inherit",
                    }}
                  >
                    {row.managerName}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor:
                        row.managerId === normalizedUserID
                          ? "#0055FF"
                          : "inherit",
                      color:
                        row.managerId === normalizedUserID
                          ? "#FFFFFF"
                          : "inherit",
                    }}
                  >
                    {row.totalCount}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor:
                        row.managerId === normalizedUserID
                          ? "#0055FF"
                          : "inherit",
                      color:
                        row.managerId === normalizedUserID
                          ? "#FFFFFF"
                          : "inherit",
                    }}
                  >
                    {row.inGreen}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor:
                        row.managerId === normalizedUserID
                          ? "#0055FF"
                          : "inherit",
                      color:
                        row.managerId === normalizedUserID
                          ? "#FFFFFF"
                          : "inherit",
                    }}
                  >
                    {row.inYellow}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor:
                        row.managerId === normalizedUserID
                          ? "#0055FF"
                          : "inherit",
                      color:
                        row.managerId === normalizedUserID
                          ? "#FFFFFF"
                          : "inherit",
                    }}
                  >
                    {row.inRed}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor:
                        row.managerId === normalizedUserID
                          ? "#0055FF"
                          : "inherit",
                      color:
                        row.managerId === normalizedUserID
                          ? "#FFFFFF"
                          : "inherit",
                    }}
                  >
                    {row.inGreenPercent}
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor:
                        row.managerId === normalizedUserID
                          ? "#0055FF"
                          : "inherit",
                      color:
                        row.managerId === normalizedUserID
                          ? "#FFFFFF"
                          : "inherit",
                    }}
                  >
                    {row.inYellowPercent}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor:
                        row.managerId === normalizedUserID
                          ? "#0055FF"
                          : "inherit",
                      color:
                        row.managerId === normalizedUserID
                          ? "#FFFFFF"
                          : "inherit",
                    }}
                  >
                    {row.inRedPercent}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default KpiTable;
